import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-annotation', 'open', 'Открыть аннотацию');
Labels.set('ui-annotation', 'close', 'Закрыть аннотацию');
